import { useState } from "react"



export default function useFood() {
  const [todayData, setTodayData] = useState<any>();
  return {
    todayData,
    setTodayData,
  }
}
